<template>
  <div class="row">
    <div class="col-md-12">
      <project-life-cycle :project="project" />
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12">
      <project-header
        v-if="relatedProjects !== null"
        @on-show-amort-tab="onShowAmortTab"
        @on-preapprove-request="onPreapproveRequest"
        @on-approve-request="onApproveRequest"
        :related-projects="relatedProjects" />
      <!--
      :relatedProjects="relatedProjects"
        @on-show-amort-tab="onShowAmortTab"
        @on-reload-project="onReloadProject"
        @on-preapprove-request="onPreapproveRequest"
        @on-approve-request="onApproveRequest"
      -->
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12">
      <credit-events-log class="mt-4" :projectId="project.id" />
      <project-message-logger />
    </div>
    <div class="container-fluid">
      <div class="col-md-12 mt-4 p-5">
        <project-detail-v2
            variant="risk-model"
            :id="project.id" ref="project_main"></project-detail-v2>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectMessageLogger from "@components/ProjectMessageLogger";
import CreditEventsLog from "@projects/CreditEventsLog";
import ProjectLifeCycle from "@components/project-details/ProjectLifeCycle";
import ProjectHeader from "@components/project-details/ProjectHeader";
import {mapActions, mapMutations, mapState} from "vuex";
import ProjectDetailV2 from "@views/admin/projectsv2/ProjectDetail.vue";

export default {
  name: "RiskCreditHeader",
  components: {ProjectDetailV2, ProjectMessageLogger, CreditEventsLog, ProjectLifeCycle, ProjectHeader},
  data: () => ({
    relatedProjects: null
  }),
  computed: {
    ...mapState('projects', ['project']),
  },
  async mounted() {

    const { data } = await axios.get(`/api/v2/projects/${this.project.id}/getProjectsRelated`);
    this.relatedProjects = data;
  },
  methods: {
    ...mapActions('projects', ['getProject']),
    ...mapMutations('projects', ['setProject']),
    async onPreapproveRequest() {
      let main = this.$refs.project_main;
      await main.preapproveRequest();

    },
    async onApproveRequest() {
      let main = this.$refs.project_main;
      await main.approveRequest();
    },
    onShowAmortTab() {
      this.$refs.project_main.showAmortTable();
    },
  }
}
</script>

<style scoped>

</style>
